(()=>{
  'use strict';

  const TIME_ZONE = 'America/New_York';
  const STYLE_ID = 'little-roar-requested-fixes-v11';
  const pad = value => String(value).padStart(2, '0');

  const EXACT_CSS = `
html body .little-roar-page[data-roar-buy-section] .lr-shipping-progress:not(.lr-free-shipping-badge-v10) {
  display: none !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Mini Roar"] .lr-offer-detail,
html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Big Roar"] .lr-offer-detail {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 2px !important;
  overflow: visible !important;
  white-space: normal !important;
  text-overflow: clip !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-card-size-v9 {
  display: block !important;
  color: #ffe69a !important;
  font-size: .46rem !important;
  font-weight: 1000 !important;
  line-height: 1 !important;
  letter-spacing: .065em !important;
  white-space: nowrap !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Mini Roar"] .lr-offer-detail span,
html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Big Roar"] .lr-offer-detail span {
  display: block !important;
  line-height: 1.15 !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Roar Together"] .lr-offer-copy {
  align-items: flex-start !important;
  text-align: left !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Roar Together"] .lr-offer-name {
  width: auto !important;
  max-width: 100% !important;
  margin: 0 !important;
  font-size: 1.42rem !important;
  line-height: 1 !important;
  letter-spacing: -.04em !important;
  white-space: nowrap !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Roar Together"] .lr-offer-name br {
  display: none !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Roar Together"] .lr-offer-price {
  display: inline-flex !important;
  width: auto !important;
  max-width: 100% !important;
  margin: 0 !important;
  align-self: flex-start !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Roar Together"] .lr-offer-price strong {
  display: inline-flex !important;
  width: auto !important;
  min-width: 116px !important;
  min-height: 32px !important;
  box-sizing: border-box !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 6px 13px !important;
  border: 1px solid rgba(255,255,255,.30) !important;
  border-radius: 11px !important;
  background: linear-gradient(145deg,#ffe477,#f8c341) !important;
  color: #0a392f !important;
  box-shadow: 0 7px 17px rgba(0,0,0,.17) !important;
  font-size: 1.04rem !important;
  font-weight: 1000 !important;
  line-height: 1 !important;
  text-align: center !important;
  text-shadow: none !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Roar Together"] .lr-save-pill {
  display: inline-flex !important;
  width: auto !important;
  max-width: 100% !important;
  min-height: 26px !important;
  box-sizing: border-box !important;
  align-items: center !important;
  justify-content: center !important;
  align-self: flex-start !important;
  margin: 8px 0 0 !important;
  padding: 7px 11px !important;
  border-radius: 999px !important;
  background: #e7744f !important;
  color: #fff !important;
  font-size: .50rem !important;
  font-weight: 1000 !important;
  line-height: 1 !important;
  letter-spacing: .025em !important;
  text-align: center !important;
  white-space: nowrap !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-free-shipping-badge-v10 {
  position: relative !important;
  display: flex !important;
  width: 100% !important;
  max-width: none !important;
  min-height: 50px !important;
  box-sizing: border-box !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 10px !important;
  margin: 18px 0 !important;
  padding: 9px 16px !important;
  overflow: hidden !important;
  border: 1px solid rgba(153,108,12,.28) !important;
  border-radius: 16px !important;
  background: linear-gradient(135deg,#fff1a8 0%,#f8d75f 48%,#efbd36 100%) !important;
  box-shadow: 0 10px 22px rgba(196,145,28,.20), inset 0 1px 0 rgba(255,255,255,.76) !important;
  color: #123f39 !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-free-shipping-badge-v10::before,
html body .little-roar-page[data-roar-buy-section] .lr-free-shipping-badge-v10::after {
  display: none !important;
  content: none !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-free-shipping-icon-v10 {
  display: inline-grid !important;
  width: 30px !important;
  height: 30px !important;
  flex: 0 0 30px !important;
  place-items: center !important;
  border-radius: 50% !important;
  background: #154f46 !important;
  color: #ffe277 !important;
  box-shadow: inset 0 1px 0 rgba(255,255,255,.14) !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-free-shipping-icon-v10 svg {
  width: 17px !important;
  height: 17px !important;
  stroke: currentColor !important;
  stroke-width: 1.8 !important;
  stroke-linecap: round !important;
  stroke-linejoin: round !important;
}

html body .little-roar-page[data-roar-buy-section] .lr-free-shipping-badge-v10 strong {
  color: #123f39 !important;
  font-size: .76rem !important;
  font-weight: 1000 !important;
  line-height: 1 !important;
  letter-spacing: .045em !important;
  text-align: center !important;
  white-space: nowrap !important;
}

@media (max-width: 719px) {
  html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Roar Together"] .lr-offer-name {
    font-size: 1.34rem !important;
  }

  html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Roar Together"] .lr-offer-price strong {
    min-width: 110px !important;
    min-height: 31px !important;
    padding: 6px 12px !important;
    font-size: .98rem !important;
  }

  html body .little-roar-page[data-roar-buy-section] .lr-free-shipping-badge-v10 {
    min-height: 48px !important;
    margin: 18px 0 !important;
    padding: 8px 13px !important;
  }

  html body .little-roar-page[data-roar-buy-section] .lr-free-shipping-badge-v10 strong {
    font-size: .72rem !important;
  }
}

@media (max-width: 380px) {
  html body .little-roar-page[data-roar-buy-section] .lr-offer-card[data-size="Roar Together"] .lr-offer-name {
    font-size: 1.22rem !important;
  }

  html body .little-roar-page[data-roar-buy-section] .lr-free-shipping-badge-v10 strong {
    font-size: .66rem !important;
    letter-spacing: .03em !important;
  }
}
`;

  const zonedFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: TIME_ZONE,
    year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });

  function mountExactStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = EXACT_CSS;
    (document.body || document.head || document.documentElement).appendChild(style);
  }

  function getZonedParts(date) {
    const values = {};
    zonedFormatter.formatToParts(date).forEach(part => {
      if (part.type !== 'literal') values[part.type] = part.value;
    });
    return {
      year: Number(values.year), month: Number(values.month), day: Number(values.day),
      hour: Number(values.hour), minute: Number(values.minute), second: Number(values.second),
      weekday: values.weekday
    };
  }

  function zonedDateTimeToUtc(year, month, day, hour, minute, second) {
    let timestamp = Date.UTC(year, month - 1, day, hour, minute, second);
    for (let attempt = 0; attempt < 3; attempt += 1) {
      const parts = getZonedParts(new Date(timestamp));
      const representedAsUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      const correction = representedAsUtc - timestamp;
      if (correction === 0) break;
      timestamp -= correction;
    }
    return timestamp;
  }

  function nextSundayEnd(now = new Date()) {
    const localNow = getZonedParts(now);
    const weekdayIndex = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[localNow.weekday];
    const calendarDate = new Date(Date.UTC(localNow.year, localNow.month - 1, localNow.day, 12));
    calendarDate.setUTCDate(calendarDate.getUTCDate() + ((7 - weekdayIndex) % 7));
    let target = zonedDateTimeToUtc(calendarDate.getUTCFullYear(), calendarDate.getUTCMonth() + 1, calendarDate.getUTCDate(), 23, 59, 59);
    if (target <= now.getTime()) {
      calendarDate.setUTCDate(calendarDate.getUTCDate() + 7);
      target = zonedDateTimeToUtc(calendarDate.getUTCFullYear(), calendarDate.getUTCMonth() + 1, calendarDate.getUTCDate(), 23, 59, 59);
    }
    return target;
  }

  function setText(node, value) {
    if (node && node.textContent.trim() !== value) node.textContent = value;
  }

  function setHtml(node, value) {
    if (node && node.innerHTML.trim() !== value) node.innerHTML = value;
  }

  function mountCountdown(card) {
    const badge = card.querySelector('.lr-pack-extra-v4, .lr-extra-badge');
    if (!badge) return;
    badge.dataset.lrSundayCountdownV8 = '1';
    badge.classList.add('lr-sunday-countdown-v7');
    badge.setAttribute('role', 'timer');
    badge.setAttribute('aria-live', 'off');
    if (!badge.querySelector('[data-lr-days-v8]')) {
      badge.innerHTML = '<span class="lr-sunday-countdown-label-v7">OFFER ENDS SUNDAY</span><span class="lr-sunday-countdown-time-v7" aria-hidden="true"><b data-lr-days-v8>00D</b><b data-lr-hours-v8>00H</b><b data-lr-minutes-v8>00M</b></span>';
    }
  }

  function updateCountdown() {
    const now = new Date();
    const remaining = Math.max(0, Math.floor((nextSundayEnd(now) - now.getTime()) / 60000));
    const days = Math.floor(remaining / 1440);
    const hours = Math.floor((remaining % 1440) / 60);
    const minutes = remaining % 60;
    document.querySelectorAll('.lr-sunday-countdown-v7').forEach(timer => {
      const d = timer.querySelector('[data-lr-days-v8]');
      const h = timer.querySelector('[data-lr-hours-v8]');
      const m = timer.querySelector('[data-lr-minutes-v8]');
      if (d) d.textContent = `${pad(days)}D`;
      if (h) h.textContent = `${pad(hours)}H`;
      if (m) m.textContent = `${pad(minutes)}M`;
      timer.setAttribute('aria-label', `Offer ends Sunday at 11:59 PM U.S. Eastern Time. ${days} days, ${hours} hours and ${minutes} minutes remaining.`);
    });
  }

  function updateOfferCards(root) {
    root.querySelectorAll('.lr-offer-card[data-size]').forEach(card => {
      const size = card.dataset.size;
      const detail = card.querySelector('.lr-offer-detail');

      if (size === 'Mini Roar') {
        setHtml(detail, '<b class="lr-card-size-v9">90 CM · ABOUT 3 FT</b><span>One cuddly Mini Roar</span>');
      }

      if (size === 'Big Roar') {
        setHtml(detail, '<b class="lr-card-size-v9">120 CM · ABOUT 4 FT</b><span>One full-size Big Roar</span>');
      }

      if (size === 'Roar Together') {
        setText(card.querySelector('.lr-offer-name'), 'Pick Any 3');
        setText(card.querySelector('.lr-save-pill'), 'FREE WORLDWIDE SHIPPING');
        mountCountdown(card);
      }
    });
  }

  function replaceGlowOffer(root) {
    const badge = root.querySelector('.lr-free-shipping-badge-v10, [data-shipping-progress], .lr-shipping-progress');
    if (!badge) return;
    if (badge.className !== 'lr-free-shipping-badge-v10') badge.className = 'lr-free-shipping-badge-v10';
    badge.removeAttribute('data-shipping-progress');
    badge.setAttribute('role', 'note');
    badge.setAttribute('aria-label', 'Free worldwide shipping');
    setHtml(badge, '<span class="lr-free-shipping-icon-v10" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8.5"></circle><path d="M3.5 12h17M12 3.5c2.2 2.3 3.35 5.1 3.35 8.5S14.2 18.2 12 20.5C9.8 18.2 8.65 15.4 8.65 12S9.8 5.8 12 3.5Z"></path></svg></span><strong>FREE WORLDWIDE SHIPPING</strong>');
  }

  function updateBundleFaq() {
    document.querySelectorAll('.lr-faq-item, details').forEach(item => {
      const question = item.querySelector('.lr-faq-question span:first-child, summary span:first-child, summary');
      if (!question) return;
      const current = question.textContent.trim();
      if (!/(buy\s*3.*free.?gift|how does the pick any 3 offer work)/i.test(current)) return;
      setText(question, 'How does the Pick Any 3 offer work?');
      const answer = item.querySelector('.lr-faq-answer p, .lr-faq-answer, [data-faq-answer], .accordion__content p, .accordion__content');
      setText(answer, 'Choose any 3 Little Roars. Each one can be Mini or Big and any available colour. The pack is €89.99 in EUR or $99.99 in USD, with free worldwide shipping included.');
    });
  }

  function updateAnnouncement() {
    document.querySelectorAll('[data-roar-announcement], .little-roar-announcement').forEach(bar => {
      const walker = document.createTreeWalker(bar, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        const node = walker.currentNode;
        const value = node.nodeValue.replace(/FREE SHIPPING OFFER/gi, 'FREE WORLDWIDE SHIPPING').replace(/FREE SHIPPING DEAL/gi, 'FREE WORLDWIDE SHIPPING');
        if (value !== node.nodeValue) node.nodeValue = value;
      }
    });
  }

  function updateFooterPolicies() {
    const footer = document.querySelector('.little-roar-footer, [data-roar-footer]');
    if (!footer) return;
    const linkContainer = footer.querySelector('.lr-footer-links, nav, ul');
    if (!linkContainer) return;
    const existing = Array.from(linkContainer.querySelectorAll('a')).map(link => link.getAttribute('href'));
    [
      ['/policies/refund-policy', 'Refund policy'],
      ['/policies/privacy-policy', 'Privacy policy'],
      ['/policies/terms-of-service', 'Terms of service'],
      ['/policies/shipping-policy', 'Shipping policy'],
      ['/pages/contact', 'Contact']
    ].forEach(([href, label]) => {
      if (existing.some(value => value && value.includes(href))) return;
      const link = document.createElement('a');
      link.href = href;
      link.textContent = label;
      linkContainer.appendChild(link);
    });
  }

  function applyRequestedChanges() {
    mountExactStyles();
    const root = document.querySelector('[data-roar-buy-section]');
    if (root) {
      updateOfferCards(root);
      replaceGlowOffer(root);
    }
    updateBundleFaq();
    updateAnnouncement();
    updateFooterPolicies();
    updateCountdown();
  }

  let scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      applyRequestedChanges();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleApply, { once: true });
  else scheduleApply();

  document.addEventListener('shopify:section:load', scheduleApply);
  new MutationObserver(scheduleApply).observe(document.documentElement, { childList: true, subtree: true });
  window.setInterval(updateCountdown, 1000);
})();
